import { Fragment, useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
    addPartnerCampaignAction,
    deletePartnerCampaignAction,
    loadPartnerCampaignsAction,
    updatePartnerCampaignAction
} from "../partnerActions";
import { Button, Table } from "react-bootstrap";
import _ from "lodash";
import { getPartnerCampaigns, getPartnerParams, getPartnerPostbacksGroupedByCampaignId } from "../partnerSelectors";
import { formReferralLink } from "../partnerUtils";
import { PartnerCampaignForm } from "./PartnerCampaignForm";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

const PartnerCampaigns = (props) => {
    const {
        addPartnerCampaignAction,
        campaigns,
        deletePartnerCampaignAction,
        loadPartnerCampaignsAction,
        params,
        postbacksGroupedByCampaignId,
        updatePartnerCampaignAction,
    } = props;
    const {getLangPath} = useLangContext();
    const [selectedCampaign, setSelectedCampaign] = useState({});
    const [isShowAddCampaignForm, setIsShowAddCampaignForm] = useState(false);

    useEffect(() => {
        loadPartnerCampaignsAction();
    }, [loadPartnerCampaignsAction]);

    const handleRowClick = useCallback((e) => {
        setSelectedCampaign(_.find(campaigns, {id: parseInt(e.currentTarget.dataset.id)}));
    }, [campaigns]);

    const updateCampaignFormSubmit = useCallback((campaignParams) => {
        updatePartnerCampaignAction({
            ...campaignParams,
            id: selectedCampaign.id,
        });
    }, [selectedCampaign.id, updatePartnerCampaignAction]);

    const updateCampaignFormCancel = useCallback(() => {
        setSelectedCampaign({});
    }, [])

    const addCampaignFormSubmit = useCallback((campaignParams) => {
        addPartnerCampaignAction(campaignParams);
        setIsShowAddCampaignForm(false);
    }, [addPartnerCampaignAction]);

    const addCampaignFormCancel = useCallback(() => {
        setIsShowAddCampaignForm(false);
    }, []);

    const handleAddButtonClick = useCallback(() => {
        setIsShowAddCampaignForm(true);
    }, []);

    const handleDeleteButtonClick = useCallback(() => {
        const isConfirmed = window.confirm(getLangPath('partner.campaigns.confirm'));
        if (isConfirmed) {
            deletePartnerCampaignAction({id: selectedCampaign.id})
        }
    }, [deletePartnerCampaignAction, getLangPath, selectedCampaign.id])

    return <>
        <Table striped bordered hover variant="dark">
            <thead>
            <tr>
                <th>{getLangPath('partner.campaign_name')}</th>
                <th>{getLangPath('partner.campaign_channel')}</th>
                <th>{getLangPath('partner.campaigns.referral_link')}</th>
            </tr>
            </thead>
            <tbody>
            {
                _.sortBy(campaigns, 'campaign_name').map((campaign) => {
                    return (
                            <Fragment key={campaign.id}>
                                <tr data-id={campaign.id} onClick={handleRowClick}>
                                    <td>{campaign.campaign_name}</td>
                                    <td>{campaign.campaign_channel}</td>
                                    <td>{formReferralLink({
                                        refshare: params.refshare,
                                        campaign: campaign.campaign_name,
                                        channel: campaign.campaign_channel,
                                    })}</td>
                                </tr>
                                {
                                        selectedCampaign.id === campaign.id && (
                                                <tr>
                                                    <td colSpan="3" className="p-0">
                                                        <PartnerCampaignForm
                                                                campaignId={campaign.id}
                                                                channelDefaultValue={campaign.campaign_channel}
                                                                nameDefaultValue={campaign.campaign_name}
                                                                onDelete={handleDeleteButtonClick}
                                                                onCancel={updateCampaignFormCancel}
                                                                onSubmit={updateCampaignFormSubmit}
                                                                refshare={params.refshare}
                                                                postbacksList={postbacksGroupedByCampaignId[campaign.id] || []}
                                                        />
                                                    </td>
                                                </tr>
                                        )
                                }
                            </Fragment>
                    );
                })
            }
            </tbody>
        </Table>
        <div>
            {
                isShowAddCampaignForm ? (
                        <PartnerCampaignForm
                                onSubmit={addCampaignFormSubmit}
                                onCancel={addCampaignFormCancel}
                                refshare={params.refshare}
                        />
                ) : (
                        <Button variant="primary" size='md' onClick={handleAddButtonClick}>
                            {getLangPath('partner.campaigns.add_campaign_button')}
                        </Button>
                )
            }
        </div>
    </>
}

const mapStateToProps = createStructuredSelector({
    campaigns: getPartnerCampaigns,
    params: getPartnerParams,
    postbacksGroupedByCampaignId: getPartnerPostbacksGroupedByCampaignId
});

const mapDispatchToProps = {
    addPartnerCampaignAction,
    deletePartnerCampaignAction,
    loadPartnerCampaignsAction,
    updatePartnerCampaignAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerCampaigns)
